export default __webpack_public_path__ + "static/media/header.fc5b690d.png";